import httpClient from "@utils/httpClient";

// Get all holidays (public and optional), optionally filtered by year
export const getAllHolidays = async (year = null) => {
  try {
    const url = year ? `/hr/holidays?year=${year}` : '/hr/holidays';
    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getAllHolidays error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get all public holidays, optionally filtered by year
export const getPublicHolidays = async (year = null) => {
  try {
    const url = year ? `/hr/holidays/public?year=${year}` : '/hr/holidays/public';
    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getPublicHolidays error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get all optional holidays
export const getOptionalHolidays = async () => {
  try {
    const response = await httpClient.get('/hr/holidays/optional');

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getOptionalHolidays error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get employees for a specific optional holiday
export const getEmployeesForOptionalHoliday = async (holidayId) => {
  try {
    const response = await httpClient.get(`/hr/holidays/optional/${holidayId}/employees`);

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getEmployeesForOptionalHoliday error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Add a new holiday
export const addHoliday = async (holidayData) => {
  try {
    const response = await httpClient.post('/hr/holidays', holidayData);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('addHoliday error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Update a holiday
export const updateHoliday = async (holidayId, updateData) => {
  try {
    const response = await httpClient.put(`/hr/holidays/${holidayId}`, updateData);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('updateHoliday error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Delete a holiday
export const deleteHoliday = async (holidayId) => {
  try {
    const response = await httpClient.delete(`/hr/holidays/${holidayId}`);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('deleteHoliday error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get all employee selections, optionally filtered by year
export const getAllEmployeeSelections = async (year = null) => {
  try {
    const url = year ? `/hr/holidays/selections/all?year=${year}` : '/hr/holidays/selections/all';
    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getAllEmployeeSelections error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get HR's selected optional holidays
export const getHRSelectedOptionalHolidays = async () => {
  try {
    const response = await httpClient.get('/hr/holidays/my-selections');

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getHRSelectedOptionalHolidays error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Submit HR's optional holiday selection
export const submitHRHolidaySelection = async (holidayIds) => {
  try {
    const response = await httpClient.post('/hr/holidays/my-selections', { holidayIds });

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('submitHRHolidaySelection error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Edit employee's selected holidays (bulk remove and replace)
export const editEmployeeHoliday = async (userId, removeHolidayIds, addHolidayIds) => {
  try {
    const response = await httpClient.put(`/hr/holidays/employee/${userId}/edit-holiday`, {
      removeHolidayIds,
      addHolidayIds
    });

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('editEmployeeHoliday error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Cancel employee's optional holidays (HR can cancel holidays for any employee)
export const cancelEmployeeHolidays = async (userId, holidayIds) => {
  try {
    const response = await httpClient.post(`/hr/holidays/employee/${userId}/cancel`, {
      holiday_ids: holidayIds
    });

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('cancelEmployeeHolidays error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Replace employee's optional holidays (HR can replace holidays for any employee)
export const replaceEmployeeHolidays = async (userId, cancelHolidayIds, addHolidayIds) => {
  try {
    const response = await httpClient.post(`/hr/holidays/employee/${userId}/replace`, {
      cancel_holiday_ids: cancelHolidayIds,
      add_holiday_ids: addHolidayIds
    });

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('replaceEmployeeHolidays error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Bulk add holidays
export const bulkAddHolidays = async (holidaysArray) => {
  try {
    const response = await httpClient.post('/hr/holidays/bulk', {
      holidays: holidaysArray
    });

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('bulkAddHolidays error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};